interface scrollToAnchorProps {
  id: string;
  event?: any;
  behavior?: ScrollBehavior;
}

export default function scrollToAnchor({
  id,
  event,
  behavior,
}: scrollToAnchorProps) {
  event?.preventDefault();
  if (typeof window !== "undefined") {
    const target = document.getElementById(id?.replace(/#/g, ""));
    target?.scrollIntoView({
      behavior: behavior,
    });
  }
}
